export default {
  SET_ITEMS_NO_PAGINATE(state, items) {
    state.unpaginated_elements = items
  },
  SET_CATEGORY_REASONS(state, items) {
    state.category_reasons = items
  }
}
